import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import { flattedArrayByKey } from '../../utils/helpers';
import { Autocomplete, TextField } from '@mui/material';

const EditColumns = () => {
  const dispatch = useDispatch();
  const { condition_id } = useParams();
  const [addMoreColumnsClicked, setAddMoreColumnsClicked] = useState(false);

  const { condition, tables, loadingDeleteColumn, tablesColumns } = useSelector((state) => state.general);
  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'condition',
        route: `conditions/getConditionById`,
        conditionId: condition_id,
      })
    );
    dispatch(apiAction({ reduxField: 'tables', route: 'mmData/getAllTables' }));
  }, []);

  if (condition?._id !== condition_id) {
    dispatch(
      generalSet({
        reduxField: 'condition',
        value: null,
      })
    );
  }

  console.log({ condition, tables, tablesColumns });
  return condition?._id && Array.isArray(tables) ? (
    <div>
      <div className='row justify-content-left align-items-center mt-2'>
        <div className='col-md-12'>
          <Link className='btn btn-sm btn-outline-dark border-0' to={`/condition/${condition._id}`}>
            Back to Condition Details
          </Link>
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <div
          className='col-lg-12 d-flex justify-content-center mt-2 pt-lg-0 border-bottom'
          data-aos='fade-up'
          data-aos-delay='200'
        >
          <h1>Edit Tables and Columns</h1>
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <h5>
          <Link className='text-primary' to={`/condition/${condition._id}`}>
            {condition.name}
          </Link>
        </h5>
      </div>
      {(() => {
        const columnsObj = flattedArrayByKey(condition.columns, 'table_name');
        console.log({ columnsObj });
        return Array.isArray(columnsObj) ? (
          <>
            <div
              className='row d-flex justify-content-center mt-4 pt-lg-0 mb-2'
              data-aos='fade-up'
              data-aos-delay='200'
            >
              <h6>
                Manage ({columnsObj.length}) Tables and ({condition.columns?.length}) Columns
              </h6>
            </div>
            <div className='row d-flex justify-content-center pt-lg-0'>
              {columnsObj.map((column) => {
                return (
                  <div
                    className='row d-flex justify-content-center pt-lg-0 mb-2'
                    data-aos='fade-up'
                    data-aos-delay='200'
                    key={column.table_name}
                  >
                    <div className='col-md-8 d-flex justify-content-center p-2 border'>
                      <h5 className='mt-2'>
                        <i className='fa-solid fa-table'></i> {column.table_name}
                      </h5>
                    </div>
                    <div className='col-md-8 d-flex justify-content-center p-2 flex-wrap border border-top-0'>
                      {column.items?.map((col) => {
                        return (
                          <div className='btn-group m-1' key={col._id}>
                            <div className='p-2 border rounded border-primary'>{col.column_name}</div>
                            <button
                              className='btn btn-outline-dark'
                              disabled={loadingDeleteColumn?.for === col._id}
                              onClick={() => {
                                dispatch(generalSet({ reduxField: 'loadingDeleteColumn', value: { for: col._id } }));
                                dispatch(
                                  apiAction({
                                    reduxField: 'condition',
                                    route: 'conditions/deleteColumnsByIds',
                                    conditionId: condition._id,
                                    columnIds: [col._id],
                                    setLoading: 'loadingDeleteColumn',
                                  })
                                );
                              }}
                            >
                              X
                            </button>
                          </div>
                        );
                      })}
                    </div>
                    <div className='col-md-8 d-flex justify-content-center p-2 flex-wrap border border-top-0'>
                      <button
                        className='btn btn-outline-primary'
                        onClick={() => {
                          if (addMoreColumnsClicked === column.table_name) {
                            return setAddMoreColumnsClicked(null);
                          }
                          setAddMoreColumnsClicked(column.table_name);
                          dispatch(
                            apiAction({
                              reduxField: 'tablesColumns',
                              route: 'mmData/getTableColumns',
                              tableNames: [column.table_name],
                            })
                          );
                        }}
                      >
                        Add More Columns
                      </button>
                    </div>
                    {addMoreColumnsClicked === column.table_name ? (
                      <>
                        <div className='col-md-8 d-flex justify-content-center p-2 flex-wrap border border-top-0'>
                          {(() => {
                            const filteredColumns = tablesColumns
                              ?.filter((flt) => flt.table_name === column.table_name)[0]
                              ?.columns?.filter(
                                (flt) => !column.items.map((item) => item.column_name).includes(flt.column_name)
                              );

                            if (Array.isArray(filteredColumns) && filteredColumns.length === 0) {
                              return <h6>No Additional Columns Found for this Table</h6>;
                            }
                            return filteredColumns?.map((col) => {
                              return (
                                <div className='btn-group m-1' key={col.column_name}>
                                  <div className='p-2 border rounded border-primary'>{col.column_name}</div>
                                  <button
                                    className='btn btn-outline-dark'
                                    onClick={() => {
                                      dispatch(
                                        apiAction({
                                          reduxField: 'condition',
                                          route: 'conditions/addColumnsToCondition',
                                          conditionId: condition._id,
                                          columns: [col],
                                        })
                                      );
                                    }}
                                  >
                                    +
                                  </button>
                                </div>
                              );
                            });
                          })()}
                        </div>
                      </>
                    ) : null}
                  </div>
                );
              })}
              <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
                <div className='col-md-8 d-flex justify-content-center mt-2  ' data-aos='fade-up' data-aos-delay='200'>
                  <h3>Add a Table</h3>
                </div>
                <div
                  className='col-lg-8 d-flex justify-content-center mt-2 pt-lg-0 mb-4'
                  data-aos='fade-up'
                  data-aos-delay='200'
                >
                  <Autocomplete
                    options={tables.filter((table) => !columnsObj.map((item) => item.table_name).includes(table))}
                    getOptionLabel={(option) => option}
                    //   value={selectedTable}
                    onChange={(event, newValue) => {
                      if (!tables.includes(newValue)) return null;

                      dispatch(
                        apiAction({
                          reduxField: 'condition',
                          route: 'conditions/addTableWithColumnsToCondition',
                          conditionId: condition._id,
                          tableName: newValue,
                        })
                      );
                    }}
                    renderInput={(params) => <TextField {...params} label='Select Tables' variant='outlined' />}
                    style={{ width: 300 }}
                  />
                </div>
              </div>
              <div className='m-4'></div>
            </div>
          </>
        ) : (
          <Spinner />
        );
      })()}
    </div>
  ) : (
    <Spinner />
  );
};

export default EditColumns;
